



















import { Component, Vue, Prop, Model } from 'vue-property-decorator'
import { Patient } from '@/types/user'
import InviteWorkerModalForm, {
  Props as FormProps
} from './InviteWorkerModalForm.vue'

export type Props = {
  patient: Patient | undefined
}

@Component({
  components: {
    ModalForm: InviteWorkerModalForm
  }
})
export default class InviteWorkerModal extends Vue {
  @Model('change', { type: Boolean }) show!: boolean
  @Prop(Object) readonly props!: FormProps

  get patient() {
    return this.props.patient
  }

  close() {
    this.$emit('change', false)
  }

  handleClickClose() {
    this.close()
  }

  handleSubmit() {
    this.close()
  }

  handleWorkerAdded() {
    this.$emit('added')
  }
}
